import { render } from "./permission.vue?vue&type=template&id=0ae59fe2"
import script from "./permission.vue?vue&type=script&lang=js"
export * from "./permission.vue?vue&type=script&lang=js"

import "./permission.vue?vue&type=style&index=0&id=0ae59fe2&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanyuanyuanxing\\baiwenbida-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__